import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'
const getTranslateMasterFilters = function () {
  return {
    name: { label: i18n.t('app.name'), value: '' },
    ns: { label: i18n.t('app.serial_number'), value: '' },
    partner: { label: i18n.t('clients.partner'), value: '' },
    grupoCliente: { label: i18n.t('clients.grupo_cliente'), value: '', labelValue: '' },
    tipoServicio: { label: i18n.t('clients.service_type'), value: '' }
  }
}
const getColumns = function getColumns () {
  return [
    { field: 'idCliente', width: '100px', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
    {
      field: 'Distribuidor',
      title: i18n.t('distributors.entity_name'),
      columnMenu: 'myTemplate',
      hidden: true,
      locked: false,
      width: '180px',
      only: {
        roles: [3],
      }, 
    },
    { field: 'Nombre', width: '400px', title: i18n.t('app.name'), columnMenu: 'myTemplate', locked: false },
    { field: 'NumeroSerieEmpresa', width: '400px', title: i18n.t('app.serial_number'), columnMenu: 'myTemplate', locked: false },
    { field: 'Partner', width: '150px', title: i18n.t('clients.partner'), columnMenu: 'myTemplate', locked: false },
    { field: 'GrupoCliente', width: '390px', title: i18n.t('clients.grupo_cliente'), columnMenu: 'myTemplate', locked: false },
    { field: 'MesesUserPass', width: '390px', title: i18n.t('clients.users_submenu.mesesUserPass'), columnMenu: 'myTemplate', locked: false, hidden: true },
    { field: 'TipoServicio', width: '150px', title: i18n.t('clients.service_type'), columnMenu: 'myTemplate', locked: false },
    { field: 'NumFacturas', width: '300px', title: i18n.t('license.num_invoices'), format: 'integer', cell: 'numberTemplate', columnMenu: 'myTemplate', locked: false, hidden: false },
    { field: 'NumeroCIFEmpresas', width: '200px', title: i18n.t('license.num_companies'), format: 'integer', cell: 'numberTemplate', columnMenu: 'myTemplate', locked: false, hidden: true },
    { field: 'NumeroUsuarios', width: '200px', title: i18n.t('license.num_users'), format: 'integer', cell: 'numberTemplate', columnMenu: 'myTemplate', locked: false, hidden: true },
  ] 
}
const mystore = parent({ navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
